import { makeStyles } from '@material-ui/core/styles';
import Theme from '../views/ui/Theme';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  listTextSelected: {
    width: '9vw',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
    padding: '8px 16px 0px 0px',
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listTextNonSelected: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listTextSelectedAj: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listTextNonSelectedAj: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
    padding: '8px 16px 0px 0px',
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listSubTextSelected: {
    color: Theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    padding: '0px 16px 8px 0px',
  },
  listSubTextNonSelected: {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '15px',
    padding: '0px 16px 8px 0px',
  },
  listSubTextJustify: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  secondaryTextRed: {
    color: 'rgba(255, 0, 0, 1) !important',
  },
  highlightItem: {
    borderRight: `4px solid ${Theme.palette.primary.main}`,
  },
  highlightItemLeft: {
    borderLeft: `4px solid ${Theme.palette.primary.main}`,
  },
  nonHighlightItem: {},
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: 0,
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
  },
  popupInputContainer: {
    textAlign: 'center',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    marginLeft: '18px',
  },
  popInputs: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '45px',
    width: '375px',
    padding: '0 10px',
    marginTop: '10px',
    marginBottom: '20px',
  },
  popupBtnContainer: {
    marginTop: '25px',
    textAlign: 'center',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    marginLeft: '18px',
  },
  popCancelBtn: {
    padding: '0 50px',
    marginLeft: '30px',
    height: '45px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  listStyling: {
    height: 'auto',
    maxHeight: '95px',
    padding: '10px 9px 10px 16px',
    backgroundColor: 'white !important',
  },
  listStylingInstr: {
    height: 'auto',
    maxHeight: '50px',
    padding: '10px 9px 10px 16px',
    backgroundColor: 'white !important',
  },
  listStylingUn: {
    height: 'auto',
    maxHeight: '96px',
    padding: '10px 9px 10px 16px',
    backgroundColor: `${Theme.palette.secondary.main} !important`,
  },
  listStylingInstrUn: {
    height: 'auto',
    maxHeight: '50px',
    padding: '10px 9px 10px 16px',
    backgroundColor: `${Theme.palette.secondary.main} !important`,
  },
  resize2: {
    backgroundColor: Theme.palette.secondary.main,
    height: '25px',
    width: '90px',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '17px',
    marginBottom: '9px',
  },
}));

export default useStyles;
